export const getBottomGapX = (state) => {
  if (window.innerWidth < 440) {
    return (336 - 3 * 39) / 4;
  }

  if (window.innerWidth >= 440 && window.innerWidth < 736) {
    return (416 - 3 * 39) / 4;
  }

  if (window.innerWidth >= 736 && window.innerWidth < 1024) {
    return (425 - 3 * 39) / 4;
  }

  if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    return state
      ? (439 - 3 * 39) / 4
      : (576 - 3 * 49) / 4;
  }

  if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
    return state
      ? (590 - 3 * 50) / 4
      : (723 - 3 * 69) / 4;
  }

  return state
    ? (768 - 3 * 70) / 4
    : (909 - 3 * 89) / 4;
};

export const getCoordinates = () => {
  const elem = document.querySelector(".adding");
  const answer = document.querySelector(".answer");

  const elemRect = elem.getBoundingClientRect();
  const answerRect = answer.getBoundingClientRect();

  return [
    elemRect.x -
      answerRect.x -
      (answerRect.width - elemRect.width) / 2,

    elemRect.y -
      answerRect.y -
      (answerRect.height - elemRect.height) / 2,
  ];
};

const getFraction = (
  level
) => {
  const maxDenominator =
    level === "beginner"
      ? 5
      : level === "advanced"
      ? 20
      : 10;

  const minDenominator = 2;

  const denominator =
    Math.floor(
      Math.random() * (maxDenominator - minDenominator + 1)
    ) + minDenominator;

  let numerator;

  if (level === "advanced") {
    numerator =
      Math.floor(Math.random() * denominator) +
      denominator +
      1;
  } else {
    numerator =
      Math.floor(Math.random() * (denominator - 1)) + 1;
  }

  return `${numerator}/${denominator}`;
};

export const TopPartNumbers = (level) => {
  return [getFraction(level)];
};

export const BottomPartNumbers = (level) => {
  return [getFraction(level)];
};

export const getAnswer = (arr1, arr2) => {
  const [a, b] = arr1[0].split("/").map(Number);
  const [c, d] = arr2[0].split("/").map(Number);

  const left = a * d;
  const right = c * b;

  if (left > right) return ">";
  if (left < right) return "<";

  return "=";
};

export const getAnswers = () => {
  return [">", "<", "="].sort(() => Math.random() - 0.5);
};